"use client";

import * as React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ThePlantFloorBreadthProblem() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="the-plant-floor-breadth-problem" className="bg-background py-16 md:py-24">
      <div ref={ref} className={`container mx-auto px-4 max-w-4xl transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <h2 className="text-3xl md:text-4xl font-bold font-default text-foreground mb-8">
          Why Do Manufacturers Use Evermark?
        </h2>
        <div className="space-y-6 text-lg text-muted-foreground leading-relaxed">
          <p>
            A manufacturing plant needs more kinds of identification than almost
            any facility — equipment and machine nameplates, safety and warning
            labels, panel and circuit marking, and asset tags on everything
            maintenance has to track. Sourcing that from several vendors means
            inconsistent formats, mismatched materials, and tags that don't
            reconcile with the asset system.
          </p>
          <p>
            Evermark Industrial Solutions produces the full set from one source.
            Equipment nameplates, OSHA-style safety labels, lockout/tagout tags,
            panel marking, and serialized asset tags are engraved in metal or
            phenolic, to one consistent format, durable for the plant-floor
            environment of heat, oil, abrasion, and wash-down.
          </p>
          <p>
            Serialized asset tags are the through-line. Evermark Industrial
            Solutions produces numbered and barcoded asset tags that feed a
            maintenance or CMMS program, so every machine, motor, and pump on
            the floor is identified and trackable to the plant's scheme.
          </p>
        </div>
      </div>
    </section>;
}